import { HttpClient } from '@angular/common/http';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader } from '@ngx-translate/core';

import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { inject } from '@angular/core';
import { APP_VERSION } from '../../version';

export const translationNotFoundMessage = 'translation-not-found';

export class MissingTranslationHandlerImpl implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return `${translationNotFoundMessage}[${params.key}]`;
  }
}

export function HttpLoaderFactory() {
  return new ComponentBasedHttpLoader();
}

export function missingTranslationHandler(): MissingTranslationHandler {
  return new MissingTranslationHandlerImpl();
}

export class ComponentBasedHttpLoader implements TranslateLoader {
  readonly #http = inject(HttpClient);

  public getTranslation(lang: string): Observable<any> {
    const requests = LIST_FILES.map(component => this.#http.get(`i18n/${lang}/${component}.json?v=${APP_VERSION}`));
    return forkJoin(requests).pipe(
      map(response => {
        return response.reduce((acc, current) => {
          return this.deepMerge(acc, current);
        }, {});
      })
    );
  }

  private deepMerge(target: any, source: any): any {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        if (typeof source[key] === 'object' && source[key] !== null) {
          if (!target[key]) {
            target[key] = {};
          }
          this.deepMerge(target[key], source[key]); // Fusion récursive
        } else {
          target[key] = source[key];
        }
      }
    }
    return target;
  }
}

export const LIST_FILES: string[] = [
  'acceptance',
  'account-creation-transporter-configuration',
  'accounting-code-format',
  'accounting-code-size',
  'accounting-code-transporter-configuration',
  'accounting-export',
  'accounting-transporter-configuration',
  'activate',
  'admin-tools',
  'availableItem',
  'bary-file-upload',
  'bary-wiki-link',
  'basket',
  'basketOrder',
  'bill',
  'boolean',
  'botHistory',
  'buttons',
  'calculationMethod',
  'cancel-transport-order',
  'cart',
  'cgu',
  'cgv',
  'cgv-transporter-configuration',
  'civility',
  'color-transporter-configuration',
  'commercial',
  'commercial-statistics',
  'commitment',
  'components',
  'components-list',
  'configuration',
  'cookie-config',
  'cookies',
  'cta-user-action',
  'customer',
  'customer-card',
  'customer-statistics',
  'cutOff',
  'dashboard',
  'data',
  'delete-transport-orders',
  'delete-users',
  'deliveryStatus',
  'deliveryStep',
  'directionalCode',
  'document-transporter-configuration',
  'domain-name-transporter-configuration',
  'edi-transporter-configuration',
  'ediHistory',
  'enable-transporter-configuration',
  'error',
  'estimate',
  'estimation-delivery.step',
  'estimation-extra-condition-step',
  'estimation-items-step',
  'estimation-my-addresses',
  'estimation-pickup.step',
  'estimation-transport-extra-condition',
  'estimation-tunnel',
  'filters',
  'forms',
  'fr',
  'gazole-indice-transporter-configuration',
  'gazoleTaxIndice',
  'gazoleTaxValue',
  'global',
  'handlingType',
  'headband',
  'health',
  'hi-robot',
  'history',
  'historyStatus',
  'home',
  'homepage',
  'how-to',
  'impersonate',
  'importHistory',
  'importType',
  'insurance-included',
  'insurance-item-list',
  'insurance-row',
  'insurance-transporter-configuration',
  'insuranceItem',
  'invoiceStatus',
  'itemCondition',
  'legal-notices',
  'login',
  'logo-uploader',
  'logs',
  'mailto',
  'merchandises',
  'metrics',
  'middle',
  'middle-customer',
  'middle-customer-pricing-data',
  'middle-customer-user-typology',
  'middle-resources',
  'modals',
  'moderators',
  'my-registered-addresses',
  'my-registered-addresses-list',
  'my-transport',
  'my-transports',
  'new-shop-form',
  'notification',
  'offer',
  'offerDescriptionItem',
  'offerEstimation',
  'offerHandlingType',
  'offerModification',
  'offerModificationHandlingType',
  'offerStatus',
  'offerVisibility',
  'order-tunnel',
  'paiment-confirmation',
  'password',
  'paymentFileQueue',
  'paymentFileType',
  'paymentPeriod',
  'paymentTransaction',
  'payzen-transporter-configuration',
  'price-list-transporter-configuration',
  'pricing',
  'pricing-search',
  'pricing-transporter-configuration',
  'pricingItem',
  'pricingItemScope',
  'pricingOption',
  'pricingOptionType',
  'pricingRule',
  'quotation-status',
  'quotationHistory',
  'quotations',
  'quotationStatus',
  'refAdr',
  'refDimension',
  'register',
  'registered-address-validator',
  'registeredAddress',
  'reset',
  'scheduler-transporter-configuration',
  'service',
  'sessions',
  'settings',
  'sidebar',
  'sidenav-transporter-configuration',
  'specialPlace',
  'specialPlaceListType',
  'specialPlacePricing',
  'specialPlacePricingItem',
  'statistics',
  'tableList',
  'task',
  'taskResult',
  'taskType',
  'tax',
  'theme',
  'theme-data',
  'track-and-trace-standalone',
  'translation',
  'transport',
  'transport-card',
  'transport-edi-history',
  'transport-lines',
  'transport-plan',
  'transporter',
  'transporter-group',
  'transporter-members',
  'transporterConfiguration',
  'transporterMails',
  'transportExtraCondition',
  'transportIncidentItem',
  'transportItem',
  'transportOrder',
  'transportOrderItem',
  'transportStep',
  'transportType',
  'transportTypology',
  'unvalited-baskets',
  'upload-acceptance',
  'upload-customer',
  'upload-directional-code',
  'upload-special-destination',
  'user-management',
  'userData',
  'userTypology',
  'validation-step',
];
